import { QuoteDiscountTerms } from '../../QuotePage.types';

export type PersonalisedQuotePricing = {
  promoText: string | null;
  basePrice: number | null;
  monthlyPrice: number;
  showAchNote: boolean;
};

/**
 * Applies the QuotePageRadio discount display rules to the personalised quote page.
 *
 * @param discountTerms Output of getDiscountDisplayData for the quote.
 * @param show2MonthsPromotion Whether the 2 month purchase date promotion replaces the discount.
 */
export const getPersonalisedQuotePricing = (
  discountTerms: QuoteDiscountTerms,
  show2MonthsPromotion: boolean,
): PersonalisedQuotePricing => {
  const {
    discountPercentage,
    discountTerm,
    periodOfCover,
    discountPaymentType,
    netFirstPaymentAmount,
    netFirstPaymentAmountAfterPromotionalPeriod,
  } = discountTerms;

  if (show2MonthsPromotion || !discountPercentage) {
    return {
      promoText: null,
      basePrice: null,
      monthlyPrice: netFirstPaymentAmount,
      showAchNote: false,
    };
  }

  const isAch = discountPaymentType === 'ach';
  const marker = isAch ? '*' : '';
  const percentage = Math.round(discountPercentage);
  const promoText =
    discountTerm && discountTerm < periodOfCover
      ? `${percentage}% off for first ${discountTerm} months${marker}`
      : `${percentage}% off${marker}`;
  const basePrice =
    netFirstPaymentAmountAfterPromotionalPeriod &&
    netFirstPaymentAmountAfterPromotionalPeriod > netFirstPaymentAmount
      ? netFirstPaymentAmountAfterPromotionalPeriod
      : null;

  return { promoText, basePrice, monthlyPrice: netFirstPaymentAmount, showAchNote: isAch };
};
